import { connect } from 'react-redux';
import AllTransactionsPage from './allTransactions.page';

const mapStateToProps = (state) => {
	return {
		deviceType: state.app.deviceType,
	};
};

const AllTransactionsContainer = connect(
	mapStateToProps,
	null,
)(AllTransactionsPage);

export default AllTransactionsContainer;
